<template>
  <div class="feature-bootcamp">
    <span v-if="userRegistered" class="feature-bootcamp__has-registered"
      >You're registered!</span
    >
    <div class="feature-bootcamp__content">
      <div class="feature-bootcamp__header">
        <div class="feature-bootcamp__header-label">
          {{ bootcampTextHeader }}
        </div>
        <div class="feature-bootcamp__header-info">
          <div class="feature-bootcamp__header-date">{{ bootcampDate }}</div>
          <div class="feature-bootcamp__header-type">
            <Passes :passName="learningAreaName" :size="24" laNoBorders />
          </div>
          <div class="feature-bootcamp__header-name">
            {{ learningAreaName }}
          </div>
        </div>
        <span
          v-if="userRegistered"
          class="feature-bootcamp__has-registered--mobile"
          >You're registered!</span
        >
      </div>
      <h2 class="feature-bootcamp__title">
        {{ bootcamp.name }}
      </h2>
      <div class="feature-bootcamp__instructors">
        With {{ contentInstructors }}
      </div>
      <div class="feature-bootcamp__description">
        {{ bootcamp.description }}
      </div>
      <div class="feature-bootcamp__cta">
        <router-link
          :to="{ name: 'bootcamp', params: { id: bootcamp.id } }"
          class="btn btn--secondary"
          >See details</router-link
        >
      </div>
    </div>
    <div class="feature-bootcamp__instructors-reel">
      <InstructorsReel
        :instructors="bootcamp.instructors"
        :learningAreaName="learningAreaName"
        :bootcamp="bootcamp"
      />
      <div class="feature-bootcamp__background-1"></div>
      <div class="feature-bootcamp__background-2"></div>
      <div class="feature-bootcamp__background-3"></div>
    </div>
    <div class="feature-bootcamp__description--mobile">
      {{ bootcamp.description }}
    </div>
    <div class="feature-bootcamp__cta--mobile">
      <router-link
        :to="{ name: 'bootcamp', params: { id: bootcamp.id } }"
        class="btn btn--secondary"
        >See details</router-link
      >
    </div>
  </div>
</template>

<script>
import { localTimezone, bootcampCommons } from '@/helpers/mixins'
import InstructorsReel from './InstructorsReel.vue'
import Passes from '../../../properties/Passes.vue'

export default {
  mixins: [localTimezone, bootcampCommons],
  components: {
    InstructorsReel,
    Passes,
  },
  props: {
    bootcamp: {
      type: Object,
      required: true,
    },
    bootcampTextHeader: {
      type: String,
      required: true,
    },
    isMobile: {
      type: Boolean,
      required: true,
    },
  },
  data: () => {
    return {
      isContentLoading: false,
    }
  },
}
</script>
<style lang="scss" scoped>
.feature-bootcamp {
  display: flex;
  position: relative;
  margin-bottom: 50px;
  padding: 0;
  flex-direction: column;
  @include mobile {
    flex-direction: row;
    margin-bottom: 60px;
  }
  &__content {
    flex: 1 1 100%;
    @include tablet {
      flex: 1 1 50%;
    }
  }
  &__header {
    position: relative;
    display: flex;
    text-transform: capitalize;
    font-family: var(--font-book);
    font-size: rem(14px);
    line-height: 20px;
    flex-direction: column;
    @include mobile {
      flex-direction: row;
      align-items: center;
      padding: 0;
    }
    &-label {
      position: relative;
      width: fit-content;
      color: var(--white);
      padding: 7px 17.26px 6px 11px;
      background: var(--purple-gradient);
      display: inline;
      margin-bottom: 35px;
      @include mobile {
        margin-bottom: 0;
      }
      &::after {
        content: '';
        position: absolute;
        background: var(--darker-gray);
        width: 9px;
        height: 36px;
        right: -4px;
        top: 0;
        transform: rotate(12deg);
      }
    }
    &-info {
      display: flex;
      flex: 1 1;
      justify-content: row;
      align-items: center;
    }
    &-date {
      height: rem(33px);
      align-items: center;
      display: flex;
      color: var(--purple-pale);
      margin-left: 0;
      margin-right: 8px;
      padding-right: 10px;
      border-right: 1px solid var(--perfect-gray);
      @include mobile {
        margin-left: 14px;
      }
    }
    &-type {
      display: flex;
      align-items: center;
    }
    &-name {
      display: flex;
      align-content: center;
      font-size: rem(14px);
      margin-left: 3.5px;
    }
  }
  &__title {
    font-size: rem(20px);
    line-height: 26px;
    font-family: var(--font-bold);
    max-width: 490px;
    margin: 10px 0 0 0;
    @include mobile {
      font-size: rem(24px);
      line-height: 1.15;
      margin: 10px 0 10px 0;
    }
  }
  &__instructors {
    font-size: rem(16px);
    line-height: 24px;
    font-family: var(--font-book);
    margin: 0;
    max-width: 490px;
    @include mobile {
      font-size: rem(16px);
      line-height: 1.2;
      margin: 10px 0 10px 0;
    }
  }
  &__instructors-reel {
    position: relative;
    flex: 1 1 100%;
    justify-content: center;
    display: flex;
    margin: 25px 0 18px auto;
    @include mobile {
      flex: 1 1 50%;
      width: 50%;
      margin-bottom: 0;
      margin-top: 0;
    }
    width: 100%;
  }
  &__description {
    display: none;
    font-size: rem(14px);
    font-weight: 400;
    margin-bottom: rem(28px);
    color: var(--athens-gray);
    @include mobile {
      display: block;
    }
    &--mobile {
      display: block;
      font-size: rem(14px);
      font-weight: 400;
      margin-bottom: 20px;
      margin-top: 30px;
      color: var(--athens-gray);
      @include mobile {
        display: none;
      }
    }
  }
  &__has-registered,
  &__has-registered--mobile {
    position: absolute;
    right: 0;
    top: 5px;
    padding: 5px 8px;
    margin: 0;
    font-size: rem(12px);
    line-height: 15px;
    border-radius: 30px;
    color: var(--charcoal);
    background: var(--positive-light);
    box-shadow: 0px 0px 10px var(--chetwode-blue-50);
  }
  &__has-registered--mobile {
    @include mobile {
      display: none;
    }
  }
  &__has-registered {
    display: none;

    @include mobile {
      display: block;
      top: -25px;
    }
  }
  &__action-icon {
    color: var(--green);
    margin-right: 3px;
    @include mobile {
      margin-left: 1em;
      margin-right: 0.3em;
    }
  }
  &__cta {
    display: none;
    flex-wrap: wrap;
    @include mobile {
      display: flex;
    }
    &--mobile {
      display: flex;
      flex-wrap: wrap;
      @include mobile {
        display: none;
      }
      .btn {
        height: 36px;
        width: 100%;
        font-size: rem(14px);
        line-height: 20px;
      }
    }
  }
  &__background-1 {
    position: absolute;
    width: 197.24px;
    height: 264px;
    transform: rotate(180deg);
    left: 67px;
    top: 21px;
    background: var(--purple-gradient);
    mix-blend-mode: normal;
    opacity: 0.21;
    filter: blur(82px);
    @include mobile {
      width: 254px;
      height: 254px;
      left: calc(50% - 215px);
    }
  }
  &__background-2 {
    position: absolute;
    width: 158px;
    height: 210px;
    right: 52px;
    top: 30px;
    opacity: 0.43;
    background: var(--orange);
    mix-blend-mode: screen;
    filter: blur(82px);
    transform: rotate(180deg);
    @include mobile {
      width: 204px;
      height: 203px;
      right: calc(50% - 200px);
      top: 35px;
      opacity: 0.23;
    }
  }
  &__background-3 {
    position: absolute;
    width: 142.87px;
    height: 182.96px;
    right: calc(50% - 270px);
    top: 50px;
    opacity: 0.25;
    background: var(--dark-blue);
    mix-blend-mode: screen;
    filter: blur(52px);
    transform: rotate(180deg);
    @include mobile {
      width: 178.66px;
      height: 176.03px;
      right: calc(50% - 170px);
      top: 50px;
      opacity: 0.25;
    }
  }
}
</style>
